import { render } from "./SpecialDayFormSidebar.vue?vue&type=template&id=6ba2594b"
import script from "./SpecialDayFormSidebar.vue?vue&type=script&lang=js"
export * from "./SpecialDayFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__